import Link from "next/link";
import { type JSX } from "react";

export type ContainerLinkProps = {
  link?: {
    href?: string;
    label?: string;
    external?: boolean;
  };
} & Omit<JSX.IntrinsicElements["a"], "href">;

export function ContainerLink({ link, children, ...rest }: ContainerLinkProps) {
  if (!link?.href) return children;
  return (
    <Link
      href={link.href}
      rel={link.external ? "noreferer noopen" : undefined}
      aria-label={link.label}
      {...rest}
    >
      {children}
    </Link>
  );
}
